// extracted by mini-css-extract-plugin
export default {"ingredientBadge":"indexBadge_ingredientBadge__7c5hK","ingredientBadgeWrapper":"indexBadge_ingredientBadgeWrapper__mzlfX"};